<template>
  <el-row class="warp">
    <el-col :span="24" class="warp-breadcrum">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/' }"><b>首页</b></el-breadcrumb-item>
        <el-breadcrumb-item>菜单列表</el-breadcrumb-item>
      </el-breadcrumb>
    </el-col>
    <el-col :span="24" class="warp-main" v-loading="loading" element-loading-text="拼命加载中">
      <!--工具条-->
      <el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
        <el-form :inline="true" size="small">
          <el-form-item>
            <el-button type="primary" @click="showAddDialog(null,-1)">添加</el-button>
          </el-form-item>
        </el-form>
      </el-col>
    </el-col>
    <!--菜单表格-->
    <el-col :span="24" class="warp-main" v-loading="loading" element-loading-text="拼命加载中">
      <el-table :data="menudata" 
        highlight-current-row 
        v-loading="loading" 
        border 
        style="width: 100%;"
        row-key="id"
        :tree-props="{children: 'children', hasChildren: 'hasChildren'}"
      >
        <el-table-column type="index" width="60" fixed="left"></el-table-column>
        <el-table-column label="名称" prop="name">
           <template slot-scope="scope">
            <i :class="scope.row.icon"></i><span> {{scope.row.name}}</span>
          </template>
        </el-table-column>
        <el-table-column label="类型" prop="type">
          <template slot-scope="scope">
            <span v-for="item in dictMenuType" :key="item.value">
              <el-tag v-if="scope.row.type == item.value && item.name=='目录'" style="">{{item.name}}</el-tag>
              <el-tag v-else-if="scope.row.type == item.value && item.name=='操作'" style="color:#bbb">{{item.name}}</el-tag>
              <el-tag v-else-if="scope.row.type == item.value" style="background-color:#e1f9d5">{{item.name}}</el-tag>
              
            </span>
          </template>  
        </el-table-column>
        <el-table-column label="路径" prop="url"></el-table-column>
        <el-table-column label="权限" prop="permissions"></el-table-column>
        <el-table-column label="显示/隐藏" prop="showFlg" :formatter="formatterShow"></el-table-column>
        <el-table-column label="排序" prop="sort"></el-table-column>
        <el-table-column label="操作" width="250">
          <template slot-scope="scope">
            <el-button size="mini" :disabled="scope.row.type == 2" @click="showAddDialog(scope.row.id,scope.row.type)">增加</el-button>
            <el-button size="mini" @click="showEditDialog(scope.$index,scope.row)">编辑</el-button>
            <el-button size="mini" type="danger" @click="remove(scope.$index,scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <!-- 添加界面 -->
      <el-dialog title="新增" :visible.sync="addFormVisible" :close-on-click-modal="false">
        <el-form :model="addForm" label-width="80px" :rules="addFormRules" ref="addForm">
          <el-row>
            <el-col :span="24">
              <el-form-item label="类型" prop="type">
                <el-radio-group v-model="addForm.type">
                  <el-radio v-for="item in dictMenuType" :key="item.value" :label="item.value">{{item.name}}</el-radio>
                  <!-- <el-radio v-for="item in dictMenuType" :key="item.value" :label="item.value" :disabled="item.value <= addForm.parentType">{{item.name}}</el-radio> -->
                </el-radio-group>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="名称" prop="name">
                <el-input v-model="addForm.name" auto-complete="off"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="路径" prop="url">
                <el-input v-model="addForm.url" auto-complete="off"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="权限" prop="permissions">
                <el-input v-model="addForm.permissions" auto-complete="off"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="图标" prop="icon">
                <el-input v-model="addForm.icon" auto-complete="off"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="是否显示" prop="show">
                <el-select v-model="addForm.show" clearable placeholder="请选择">
                  <el-option v-for="(item,index) in dictShowHide" :key="index" :label="item.name" :value="item.value"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="排序" prop="sort">
                <el-input type="number" v-model="addForm.sort" auto-complete="off"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click.native="addFormVisible = false">取消</el-button>
          <el-button type="primary" @click.native="addSubmit" :loading="addLoading">提交</el-button>
        </div>
      </el-dialog>
      <!-- 编辑界面 -->
      <el-dialog title="编辑" :visible.sync="editFormVisible" :close-on-click-modal="false">
        <el-form :model="editForm" label-width="80px" :rules="editFormRules" ref="editForm">
          <el-row>
            <el-col :span="24">
              <el-form-item label="类型" prop="type">
                <el-radio-group v-model="editForm.type">
                  <el-radio v-for="item in dictMenuType" :key="item.value" :label="item.value">{{item.name}}</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="名称" prop="name">
                <el-input v-model="editForm.name" auto-complete="off"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="路径" prop="url">
                <el-input v-model="editForm.url" auto-complete="off"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="权限" prop="permissions">
                <el-input v-model="editForm.permissions" auto-complete="off"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="图标" prop="icon">
                <el-input v-model="editForm.icon" auto-complete="off"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="是否显示" prop="show">
                <el-select v-model="editForm.show" clearable placeholder="请选择">
                  <el-option v-for="(item,index) in dictShowHide" :key="index" :label="item.name" :value="item.value"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="排序" prop="sort">
                <el-input type="number" v-model="editForm.sort" auto-complete="off"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click.native="editFormVisible = false">取消</el-button>
          <el-button type="primary" @click.native="editSubmit" :loading="addLoading">提交</el-button>
        </div>
      </el-dialog>
    </el-col>
  </el-row>
</template>

<script>
  import API from '../../api/api_menu'

  export default {
    data() {
      var checkSort = (rule,value,callback) => {
        if(!/^[1-9]\d*$/.test(value)) {
          return callback(new Error('请输入正整数值'));
        }
        callback();
      };
      return {
        loading: false,
        addLoading: false,
        permsItems: [
          {key: "get", value: "get"},
          {key: "post", value: "post"},
          {key: "put", value: "put"},
          {key: "delete", value: "delete"}
        ],
        columns: [
          {
            text: '名称',
            value: 'text',
            width: 200
          },
        ],
        menudata: [],
        editFormVisible: false,
        editForm: {
          show:''
        },
        editFormRules: {
          type: [
            {required: true, message: '请选择类型', trigger: 'blur'}
          ],
          name: [
            {required: true, message: '请输入名称', trigger: 'blur'}
          ],
          sort: [
            {validator: checkSort, trigger: 'blur'}
          ]
        },
        addFormVisible: false,
        addForm: {
          type: "0",
          show:'',
        },
        addFormRules: {
          type: [
            {required: true, message: '请选择类型', trigger: 'blur'}
          ],
          name: [
            {required: true, message: '请输入名称', trigger: 'blur'}
          ],
          sort: [
            {validator: checkSort, trigger: 'blur'}
          ]
        },
        dictShowHide: [],
        dictMenuType: []
      }
    },
    methods: {
      formatterShow: function(row, column){
        var text = '';
        if(row.showFlg){
          return "显示";
        }else{
          return "隐藏";
        }
      },
      search: function () {
        let that = this
        API.menus().then(
          function (result) {
            if (result && result.code === 200) {
              that.dictShowHide = result.data.dictShowHide;
              that.dictMenuType = result.data.dictMenuType;
              console.log(result.data.dictMenuType);
              that.menudata = result.data.menuData;
            }else{
              that.$message.error({
                  showClose: true,
                  message: result.msg,
                  duration: 2000
                });
            }
          }
        )
      },
      showAddDialog: function (parentId, parentType) {
        this.search();
        if (parentType < 2) {
          // this.addForm.parentType = parentType.toString();
          this.addForm.type = (parentType + 1).toString();
        }
        this.addForm.parentId = parentId
        this.addFormVisible = true
      },
      showEditDialog: function (index, row) {
        this.search();
        this.editFormVisible = true;
        //this.editForm = Object.assign({}, menu);
        console.log(row);
        this.editForm = row;
        this.editForm.type = row.type.toString();
        this.editForm.show = row.showFlg?"1":"0";
      },
      editSubmit: function () {
        let that = this;
        this.$refs.editForm.validate(valid => {
          if (valid) {
            that.loading = true;
            let params = Object.assign({}, that.editForm);
            params.show = params.show == '0'? false: true;
            console.log(params);
            API.update(params).then(function (result) {
              if (result && parseInt(result.code) === 200) {
                that.$message.success({
                  showClose: true,
                  message: "修改成功",
                  duration: 2000
                });
                that.$refs["editForm"].resetFields();
                that.editFormVisible = false;
                that.search();
              } else {
                var msg = result.msg? result.msg: '修改失败';
                that.$message.error({
                  showClose: true,
                  message: msg,
                  duration: 2000
                });
              }
              that.loading = false;
            });
          }
        });
      },
      //新增
      addSubmit: function () {
        let that = this;
        this.$refs.addForm.validate((valid) => {
          if (valid) {
            that.loading = true;
            let para = Object.assign({}, this.addForm);
            para.show = para.show == '0'? false: true;
            API.add(para).then(function (result) {
              that.loading = false;
              if (result && parseInt(result.code) === 200) {
                that.$message.success({showClose: true, message: '新增成功', duration: 2000});
                that.$refs['addForm'].resetFields();
                that.addFormVisible = false;
                that.search();
              } else {
                var msg = result.msg? result.msg: '修改失败';
                that.$message.error({showClose: true, message: msg, duration: 2000});
              }
            }, function (err) {
              that.loading = false;
              that.$message.error({showClose: true, message: err.toString(), duration: 2000});
            }).catch(function (error) {
              that.loading = false;
              console.log(error);
              that.$message.error({showClose: true, message: '请求出现异常', duration: 2000});
            });

          }
        });
      },
      remove: function (index, row) {
        let that = this;
        this.$confirm("确认删除该记录吗?", "提示", {type: "warning"})
          .then(() => {
            that.loading = true;
            API.remove(row.id)
              .then(
                function (result) {
                  that.loading = false;
                  if (result && parseInt(result.code) === 200) {
                    that.$message.success({
                      showClose: true,
                      message: "删除成功",
                      duration: 1500
                    });
                    that.search();
                  } else {
                    var msg = result.msg? result.msg: '修改失败';
                    that.$message.error({showClose: true, message: msg, duration: 2000});
                  }
                },
                function (err) {
                  that.loading = false;
                  that.$message.error({
                    showClose: true,
                    message: err.toString(),
                    duration: 2000
                  });
                }
              )
              .catch(function (error) {
                that.loading = false;
                console.log(error);
                that.$message.error({
                  showClose: true,
                  message: "请求出现异常",
                  duration: 2000
                });
              });
          })
          .catch(() => {
          });
      }
    },
    mounted() {
      this.search();
    }
  }
</script>



// WEBPACK FOOTER //
// list.vue?5e6b3e9a